const items = [
  "RENT GURU",
  "AMSTERDAM",
  "ROTTERDAM",
  "UTRECHT",
  "DEN HAAG",
  "EINDHOVEN",
  "GRONINGEN",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-border bg-secondary/40 py-6 overflow-hidden"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-display font-bold text-2xl md:text-4xl tracking-[0.15em] text-foreground/80 flex items-center"
              >
                <span className="px-6 md:px-10">{item}</span>
                <span className="w-2 h-2 bg-foreground/40 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
